import { createComponent } from "@helpers/admin";
import VideoSectionComponent from "@template/blocks/VideoSection/component";

export const Video = createComponent({
  label: "Video",
  component: VideoSectionComponent,
  fields: {
    heading: {
      label: "Heading",
      type: "textarea",
    },
    subHeading: {
      label: "Subheading",
      type: "textarea",
    },
    videoUrl: {
      label: "Video URL",
      type: "textarea",
    },
  },
});
